const Booking = {
  keyFields: ['zencargoReference']
};

export default Booking;
